import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'prlw-all-table-tab-body',
  template: '<ng-template><ng-content></ng-content></ng-template>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AllTableTabBodyComponent {
  @ViewChild(TemplateRef)
  public readonly bodyContent!: TemplateRef<HTMLElement>;
}
